import { Component, OnInit,ViewChild } from '@angular/core';
import { RefTrackingService } from '@app/cp/shared/services/reftracking.service';
import { NotificationSettings } from '@progress/kendo-angular-notification';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-mobile-preview',
    templateUrl: './mobile-preview.component.html',
    styleUrls: ['./mobile-preview.component.scss'],
    standalone: false
})
export class MobilePreviewComponent implements OnInit {
    refTrackingService: RefTrackingService;

    loading: boolean = false;
    public featureFlagSet: any = {};

    constructor(refTrackingService: RefTrackingService, protected featureFlagService: FeatureFlagService, private globals: GlobalsService) {
        this.refTrackingService = refTrackingService;

        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
    }
    ngOnInit() {
        this.refTrackingService.PreviewDataList = [];
    }
    getTemplateForms(StepNo: number) {
        this.loading = true;
        this.refTrackingService.getTemplateForms(this.refTrackingService.TemplateIdNewTemp, StepNo).subscribe(data => {
            this.refTrackingService.PreviewDataList = data;
            if (this.refTrackingService.PreviewDataList == null || this.refTrackingService.PreviewDataList.length == 0) {
                this.globals.notifyError("Please add the desired Step(s), and save the PDF Template");
            }
            else {
                this.forDateConvertion(this.refTrackingService.PreviewDataList)
                if (this.refTrackingService.PreviewDataList[0].stepNumber == this.refTrackingService.PreviewDataList[0].totStepCount) {
                    this.refTrackingService.NextButtonText = "Finish";
                }
                else {
                    this.refTrackingService.NextButtonText = "Next";
                }
                if (this.refTrackingService.PreviewDataList[0].stepNumber == 1) {
                    this.refTrackingService.IsPreView = false;
                }
                else {
                    this.refTrackingService.IsPreView = true;
                }
            }

            this.loading = false;
        })
    }
    getdate(date: any) {
        let dateString = date;
        let newDate = new Date(dateString);
        return newDate;
    }
    public value: any = {};
    refresh() {
        this.refTrackingService.StepNo = 1;

        this.getTemplateForms(this.refTrackingService.StepNo);
    }
    previewNext() {
        let value: boolean;
        value = this.requireValidations(this.refTrackingService.PreviewDataList);
        if (this.refTrackingService.PreviewDataList[0].stepNumber == this.refTrackingService.PreviewDataList[0].totStepCount) {
            this.refTrackingService.NextButtonText = "Finish";
        }
        else {
            this.refTrackingService.NextButtonText = "Next";
        }
        if (this.refTrackingService.NextButtonText == "Finish") {
            if (value == true) {
                this.globals.notifyInfo('Steps End')
            }
        }
        else {
            if (value == true) {
                this.refTrackingService.StepNo = this.refTrackingService.StepNo + 1;
                this.getTemplateForms(this.refTrackingService.StepNo);
            }
        }
    }
    previewPrevious() {
        if (this.refTrackingService.StepNo == 1) {
            this.getTemplateForms(this.refTrackingService.StepNo);
        }
        else {
            this.refTrackingService.StepNo = this.refTrackingService.StepNo - 1;
            this.getTemplateForms(this.refTrackingService.StepNo);
            if (this.refTrackingService.PreviewDataList[0].stepNumber == this.refTrackingService.PreviewDataList[0].totStepCount) {
                this.refTrackingService.NextButtonText = "Next";
            }
        }
    }
    public isItemSelected(itemText: any, i: number, j: number): boolean {
        return this.refTrackingService.PreviewDataList[i].formComponent[j].formComponentOptions.some(item => item.componentName === itemText);
        // return this.value.some(item => item.componentName === itemText);
    }
    requireValidations(Array: any) {
        let IsValidation: boolean = false;
        for (var dd in Array[0].formComponent) {
            if (Array[0].formComponent[dd].componentType == "checkbox" && Array[0].formComponent[dd].isRequired == true) {
                for (var vv in Array[0].formComponent[dd].formComponentOptions) {
                    var CustomerCount: number = 0
                    var defaultValue = true;
                    for (var ItemCust in Array[0].formComponent[dd].formComponentOptions) {
                        if (Array[0].formComponent[dd].formComponentOptions[ItemCust].defaultValue == defaultValue) {
                            CustomerCount = CustomerCount + 1;
                        }
                    }
                    if (CustomerCount == 0) {
                        IsValidation = false;
                        this.globals.notifyError("Please fill the value for the field " + Array[0].formComponent[dd].componentName)
                        break;
                    }
                    else {
                        IsValidation = true;
                    }
                }
            }
            else if ((Array[0].formComponent[dd].componentType == "text"
                || Array[0].formComponent[dd].componentType == "textarea"
                || Array[0].formComponent[dd].componentType == "datepicker")
                && Array[0].formComponent[dd].isRequired == true) {
                if (Array[0].formComponent[dd].defaultValue != "" && Array[0].formComponent[dd].defaultValue != null && Array[0].formComponent[dd].defaultValue != undefined) {
                    IsValidation = true;
                }
                else {
                    IsValidation = false;
                    this.globals.notifyError("Please fill the value for the field " + Array[0].formComponent[dd].componentName)
                    break;
                }
            }
            else if (Array[0].formComponent[dd].componentType == "dropdown" && Array[0].formComponent[dd].isRequired == true) {
                if (Array[0].formComponent[dd].selectedOne == "00000000-0000-0000-0000-000000000000" || Array[0].formComponent[dd].selectedOne == null || Array[0].formComponent[dd].selectedOne == undefined) {
                    IsValidation = false;
                    this.globals.notifyError("Please Select Value for " + Array[0].formComponent[dd].componentName)
                    break;
                }
                else {
                    IsValidation = true;
                }
            }
            else if (Array[0].formComponent[dd].componentType == "combobox" && Array[0].formComponent[dd].isRequired == true) {
                if (Array[0].formComponent[dd].select != null && Array[0].formComponent[dd].select.length > 0) {
                    IsValidation = true;

                }
                else {
                    IsValidation = false;
                    this.globals.notifyError("Please Select Value for " + Array[0].formComponent[dd].componentName)
                    break;
                }
            }
            else if (Array[0].formComponent[dd].componentType == "Signature" && Array[0].formComponent[dd].isRequired == true) {
                if (Array[0].formComponent[dd].defaultValue != "" && Array[0].formComponent[dd].defaultValue != null && Array[0].formComponent[dd].defaultValue != undefined) {
                    IsValidation = true;
                }
                else {
                    IsValidation = false;
                    this.globals.notifyError("Please Sign the Signature in "+ Array[0].formComponent[dd].componentName)
                    break;
                }
            }
            else if (Array[0].formComponent[dd].isRequired == false) {
                IsValidation = true;
            }
            if (IsValidation == false) {
                break;
            }
        }
        return IsValidation;
    }
    forDateConvertion(array: any) {
        for (var item in array) {
            for (var inneritem in array[item].formComponent) {
                if (array[item].formComponent[inneritem].componentType == "datepicker") {
                    if (array[item].formComponent[inneritem].defaultValue == "") {
                        array[item].formComponent[inneritem].defaultValue = this.getDate(array[item].formComponent[inneritem].defaultValue);
                    }
                    else {
                        array[item].formComponent[inneritem].defaultValue = this.getDate(array[item].formComponent[inneritem].defaultValue);
                    }
                }
            }
        }
    }
    getDate(date: any) {
        let dateString: any;
        if (date == null || date == '') {
            dateString = new Date()
        }
        else {
            dateString = date;
        }
        let newDate = new Date(dateString);
        return newDate;
    }
    showImage(Base64Signature, i, j) {
        this.refTrackingService.PreviewDataList[i].formComponent[j].defaultValue = Base64Signature;
    }
    @ViewChild(SignaturePadComponent) signaturePad: SignaturePadComponent;
    drawComplete(i, j) {
        this.refTrackingService.PreviewDataList[i].formComponent[j].defaultValue = this.signaturePad.toDataURL();
    }
    clearSignature(i,j)
    {
        this.refTrackingService.PreviewDataList[i].formComponent[j].defaultValue = "";
    }
    private signaturePadOptions: Object = { // passed through to szimek/signature_pad constructor
        'minWidth': 1,
        'canvasWidth': 100,
        'canvasHeight': 300
    };
}
